import React, {useCallback, useEffect, useState} from "react";
import type {GumaProps, IAuthService} from "./AuthService";
import {AuthContext, AuthService} from "./AuthService";
import {Configuration, UserApi} from "./generated-sources/user";

type Props = {
    children?: React.ReactNode,
};

export const ProviderGuma = ({children}: Props) => {
    const [authService, setAuthService] = useState<IAuthService | null>(null);
    const [userService, setUserService] = useState<UserApi | null>();
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

    const init = useCallback((gumaProps: GumaProps) => {
        if (!authService) {
            setAuthService(new AuthService(gumaProps));
            return (userService) ?? null;
        }
    }, [authService]);

    useEffect(() => {
        if (!authService) return;
        authService.getUser().then(async (user) => {
            if (user) {
                const configuration = new Configuration({
                    accessToken: user.access_token,
                    basePath: "https://guma-base.client.sw01.faber-app.cloud/user",
                    headers: {"Authorization": `Bearer ${user.access_token}`},
                });
                setUserService(new UserApi(configuration));
                setIsAuthenticated(true);
            } else {
                const {searchParams} = new URL(window.location.href);
                const code = searchParams.get("code");
                const state = searchParams.get("state");
                if (code && state) {
                    authService.login({code, state}).then(() => window.location.replace(window.location.origin));
                } else {
                    authService.login({});
                }
            }
        });
    }, [authService]);
    return (<AuthContext.Provider value={{
            init, userService, isAuthenticated,
        }}>
            {children}
        </AuthContext.Provider>);

};

